export interface IWompiAcceptanceTokenResponse {
  acceptanceToken: string;
  permalink: string;
  type: string;
  extraFields?: Record<string, string>;
}

export interface IWompiTransactionResponse {
  providerReference: string;
  payjoyReference: string;
  status: WompiTransactionStatus;
  amountInCents: number;
}

export enum WompiTransactionStatus {
  // This enum comes from wompi-integration.
  CREATED = "CREATED",
  PENDING = "PENDING",
  DECLINED_BY_WOMPI = "DECLINED_BY_WOMPI",
  DECLINED_BY_PAYJOY = "DECLINED_BY_PAYJOY",
  ERROR = "ERROR",
  PAID = "PAID",
  SENT_TO_FE = "SENT_TO_FE",
  VOIDED = "VOIDED",
}